import { isHeyApiError } from "@/lib/hey-api-client";

/**
 * A mensagem que o servidor mandou, ou o texto de reserva.
 *
 * As rotas de times respondem `{ detail }` com a mensagem já em português — o módulo é novo
 * e não herdou o inglês das rotas portadas —, então repassá-la é melhor do que traduzir na
 * tela: "Já existe um time com este nome." e "Apenas o titular da assinatura ou um
 * administrador da conta principal podem gerir times." dizem o que aconteceu com uma
 * precisão que um texto genérico não alcança.
 */
export const mensagemDeErro = (error: unknown, fallback: string): string => {
  if (isHeyApiError(error)) {
    if (typeof error.detail === "string") return error.detail;
    if (
      error.detail &&
      typeof error.detail === "object" &&
      "message" in error.detail
    ) {
      const message = (error.detail as { message?: unknown }).message;
      if (typeof message === "string") return message;
    }
  }
  return fallback;
};

/** O `403` que diz "você não administra os times desta agência". */
export const ehAcessoNegado = (error: unknown): boolean =>
  isHeyApiError(error) && error.status === 403;

/** O `404` de time que não existe — ou que é de outra agência, que dá no mesmo. */
export const ehNaoEncontrado = (error: unknown): boolean =>
  isHeyApiError(error) && error.status === 404;
